import React from "react";
import "./Why_Choose_Us.css";

const Why_Choose_Us = () => {
  return (
    <section id="why_choose" className="why_choose">
      <div className="container">
        <div className="why_choose_title_holder">
          <h2 className="title">WHY CHOOSE US?</h2>
          <h3 className="small_title">WHY CHOOSE US?</h3>
          <p className="subtitle">
            We’ve redefined the gym experience by putting flexibility & fairness
            at the core of your fitness journey.
          </p>
        </div>

        <div className="why_choose_content_holder">
          <div className="row mt-5 justify-content-center">
            <div className="col-lg-7 order-lg-1 order-md-2 order-2">
              <div className="content_div">
                <div className="number_holder">
                  <p className="number">1</p>
                </div>
                <div className="content_holder">
                  <h5 className="content_header">
                    The Carry-Forward Advantage
                  </h5>
                  <p className="content_text">
                    Never lose a paid day again. If your subscription ends with
                    days left, they automatically roll over to your next plan.
                  </p>
                </div>
              </div>

              <div className="content_div">
                <div className="number_holder">
                  <p className="number">2</p>
                </div>
                <div className="content_holder">
                  <h5 className="content_header">
                    One App, Infinite Locations
                  </h5>
                  <p className="content_text">
                    Access a massive world of gyms - from 24/7 powerhouses to
                    boutique studios - all through one interactive map.
                  </p>
                </div>
              </div>

              <div className="content_div">
                <div className="number_holder">
                  <p className="number">3</p>
                </div>
                <div className="content_holder">
                  <h5 className="content_header">
                    Frictionless Access with QR Check-In
                  </h5>
                  <p className="content_text">
                    Skip the front-desk paperwork. Just scan your unique QR code
                    at the entrance and start your workout immediately.
                  </p>
                </div>
              </div>

              <div className="content_div">
                <div className="number_holder">
                  <p className="number">4</p>
                </div>
                <div className="content_holder">
                  <h5 className="content_header">Hybrid Training Options</h5>
                  <p className="content_text">
                    Train anywhere. Switch between in-person gym sessions & our
                    library of on-demand virtual workout videos.
                  </p>
                </div>
              </div>

              <div className="content_div">
                <div className="number_holder">
                  <p className="number">5</p>
                </div>
                <div className="content_holder">
                  <h5 className="content_header">Transparent & Verified</h5>
                  <p className="content_text">
                    No hidden fees or rigid contracts. Choose daily, weekly, or
                    monthly plans backed by verified member reviews.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-5 order-lg-2 order-md-1 order-1">
              <div className="content_img_holder">
                <img
                  src="/Assets/images/why-choose/group-1.png"
                  alt="group-img"
                  className="content_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_Choose_Us;
